import none from '../../img/leoLogo.png'

export const coffee=[
    {
      "id": "81",
      "title": "اسپرسو",
      "desciption": "40 60",
      "price": "115",
      "image": none
    },
    {
      "id": "82",
      "title": "عربیکا 100",
      "desciption": "",
      "price": "125",
      "image": none
    },
    {
      "id": "83",
      "title": "ریسترتو (روبستا)",
      "desciption": "",
      "price": "110",
      "image": none
    },
    {
      "id": "84",
      "title": "آمریکانو",
      "desciption": "",
      "price": "120",
      "image": none
    },
    {
      "id": "85",
      "title": "یونانی",
      "desciption": "",
      "price": "135",
      "image": none
    },
    {
      "id": "86",
      "title": "ترک",
      "desciption": "",
      "price": "130",
      "image": none
    },
    // {
    //   "id": "87",
    //   "title": "سایفون",
    //   "desciption": "",
    //   "price": "125",
    //   "image": none
    // },
    // {
    //   "id": "88",
    //   "title": "فرانسه",
    //   "desciption": "",
    //   "price": "104",
    //   "image": none
    // },
    {
      "id": "89",
      "title": "لانگو",
      "desciption": "",
      "price": "135",
      "image": none
    },
    {
      "id": "810",
      "title": "Amazing cafee",
      "desciption": "",
      "price": "143",
      "image": none
    },
    // {
    //   "id": "811",
    //   "title": "آمریکانو + کروسان شکلاتی",
    //   "desciption": "",
    //   "price": "145",
    //   "image": none
    // },
    {
      "id": "812",
      "title": "کوبانو",
      "desciption": "",
      "price": "140",
      "image": none
    },
    {
      "id": "813",
      "title": "گالو",
      "desciption": "",
      "price": "140",
      "image": none
    },
    {
      "id": "814",
      "title": "کورتادو",
      "desciption": "",
      "price": "175",
      "image": none
    },
    {
      "id": "815",
      "title": "آیریش اسپرسو",
      "desciption": "",
      "price": "140",
      "image": none
    }
  ]